export default __webpack_public_path__ + "static/media/monthly_donate.7fe5f2dc.svg";